import React from "react";
import { Spinner } from "components/ui";

// Consistent, theme-matching loading indicator for ChequeGuard screens.
//   <Loader />                → block: centered spinner + text (sections / pages)
//   <Loader inline />         → compact inline spinner + text (table cells, rows)
//   <Loader text="Saving…" /> → custom label
// Uses the app's themed <Spinner>, so the colour always matches the active theme.
const Loader = ({
  text = "Loading...",
  inline = false,
  size = inline ? 18 : 32,
  className = "",
}) => {
  if (inline) {
    return (
      <span className={`inline-flex items-center gap-2 text-sm text-gray-500 ${className}`}>
        <Spinner size={size} />
        {text}
      </span>
    );
  }

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-12 text-sm text-gray-500 ${className}`}
    >
      <Spinner size={size} />
      {text ? <span>{text}</span> : null}
    </div>
  );
};

export default Loader;
